
import { Box, Button, Flex, Image, Input, Text, VStack } from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import React from "react";
import { Select } from "antd";
import moment from "moment";
import Loader from "../../Components/Loader/Loader";
import { RelevanceFieldsNew } from "../../Constants/data";
import FilterToggleButton from "../../Components/Common/FilterToggleButton";
import BuyersListModals from "./BuyersListModals";
import BuyerCompanyCard from "./BuyerCompanyCard";
import useBuyersListState from "./useBuyersListState";

const compareTimeDifference = (time1: string, time2: string) => {
  const [hours1, minutes1] = time1.split(":").map(Number);
  const [hours2, minutes2] = time2.split(":").map(Number);
  const totalMinutes1 = hours1 * 60 + minutes1;
  const totalMinutes2 = hours2 * 60 + minutes2;
  return Math.abs(totalMinutes1 - totalMinutes2) > 30;
};

// Claude: split into useBuyersListState.ts (logic) + this file (JSX) 23-03-2026
const SellerHome = () => {
  const {
    navigate, user, filterToggleRef,
    relevanceData, setRelevanceData,
    sortModal, handleCloseSortModal,
    filterModal, handleCloseFilterModal,
    releModal, handleOpenRelevanceModal, handleCloseRelevanceModal,
    meetModal, verifyGateOpen, setVerifyGateOpen, handleOpenMeetModal, handleCloseMeetModal,
    notesModal, handleOpenNotesModal, handleCloseNotesModal,
    orderSort, setOrderSort, relevanceSort, setRelevanceSort,
    search, setSearch, email, setEmail,
    loading, inputs, setInputs, event, companies, accordionActive, setAccordionActive,
    sellerData, buyers, allLeads,
    filterIndustry, setFilterIndustry, filterCountry, setFilterCountry,
    industryOptions, countryOptions,
    meetResponder, setMeetResponder,
    meetConfirm, handleOpenMeetConfirmModal, handleCloseMeetConfirmModal,
    addNewBuyer, handleCloseBuyerAddModal, addBuyer,
    currentMeet, setCurrentMeet,
    userPlan, notesData, setNotesData, details,
    isNewMeetingAllowed, resetFilters, groupBuyersByCompany, buyerCompanyListItemClick, searchEmail,
    loadBuyerLeads, meetingData,
    error,
  } = useBuyersListState();

  const RelevanceFilterComponent = () => (
    <Select
      className="custom-select-noborder"
      style={{ width: "100%", border: "0px", outline: "none", height: "100%", fontFamily: '"Inter Variable", sans-serif' }}
      dropdownStyle={{ width: "auto", fontFamily: '"Inter Variable", sans-serif' }}
      onChange={(e) => setRelevanceSort(e)}
      value={relevanceSort}
      dropdownRender={(menu) => <div style={{ lineHeight: 0, margin: 0, padding: 0 }}>{menu}</div>}
      options={[
        { label: "All", value: "" },
        { label: RelevanceFieldsNew.RELEVANT.title, value: RelevanceFieldsNew.RELEVANT.status },
        { label: RelevanceFieldsNew.EXISTING.title, value: RelevanceFieldsNew.EXISTING.status },
        { label: RelevanceFieldsNew.REVIEW.title, value: RelevanceFieldsNew.REVIEW.status },
        { label: RelevanceFieldsNew.NOTRELEVANT.title, value: RelevanceFieldsNew.NOTRELEVANT.status },
      ]}
    />
  );

  return (
    <Box w={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"} minH={"100dvh"} maxH={"100dvh"} px={"30px"}
      bg={"linear-gradient(180deg, #FFF5EE 0%, #FFFFFF 100%)"}>
      {loading && <Loader />}
      <BuyersListModals
        navigate={navigate}
        addNewBuyer={addNewBuyer} handleCloseBuyerAddModal={handleCloseBuyerAddModal} addBuyer={addBuyer}
        meetConfirm={meetConfirm} handleCloseMeetConfirmModal={handleCloseMeetConfirmModal} currentMeet={currentMeet}
        meetModal={meetModal} handleCloseMeetModal={handleCloseMeetModal} meetResponder={meetResponder} sellerData={sellerData} details={details}
        verifyGateOpen={verifyGateOpen} setVerifyGateOpen={setVerifyGateOpen}
        notesModal={notesModal} handleCloseNotesModal={handleCloseNotesModal} notesData={notesData}
        sortModal={sortModal} handleCloseSortModal={handleCloseSortModal} orderSort={orderSort} setOrderSort={setOrderSort}
        filterModal={filterModal} handleCloseFilterModal={handleCloseFilterModal} relevanceSort={relevanceSort} setRelevanceSort={setRelevanceSort}
        releModal={releModal} handleCloseRelevanceModal={handleCloseRelevanceModal} relevanceData={relevanceData} reloadData={loadBuyerLeads}
      />

      {/* Claude: Dark header 16-02-2026 */}
      <Flex w={"calc(100% + 60px)"} mx={"-30px"} mt={0} px={"30px"} py={5} bg={"#0E122F"} color={"white"} alignItems={"center"} justifyContent={"space-between"}>
        <Text fontSize={"xl"} fontWeight={700}>Buyers List</Text>
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">seller (beta)</Text>

        </VStack>
      </Flex>

      {/* Claude: event filter moved to secondary filter row 20-03-2026 */}
      <VStack w={"100%"} mt={"30px"} spacing={2} alignItems={"end"}>
        <form style={{ width: "100%" }} onSubmit={(e) => {
          e.preventDefault();
          if (email) searchEmail();
          else groupBuyersByCompany(allLeads, search, orderSort, relevanceSort, filterIndustry, filterCountry);
        }}>
          <Flex w={"100%"} alignItems={"center"} flexDirection={"column"}>
            <Box border={"1px solid #E2E8F0"} borderRadius={"10px"} bg={"white"} w={"100%"} mb={2}>
              <Input placeholder="Buyer Company Name" type="text" fontSize="sm"
                _placeholder={{ color: "gray.500", fontWeight: "400", fontSize: "sm" }}
                value={search} onChange={(e) => setSearch(e.target.value)}
                border={"0px"} outline={"none"} _focus={{ outline: "none", border: "0px" }}
                h={"40px"} w={"100%"} px={2} borderColor={"gray.300"}
              />
            </Box>
            <Box border={"1px solid #E2E8F0"} borderRadius={"10px"} bg={"white"} w={"100%"}>
              <Input placeholder="Buyer Email" type="text" fontSize="sm"
                _placeholder={{ color: "gray.500", fontWeight: "400", fontSize: "sm" }}
                value={email} onChange={(e) => setEmail(e.target.value)}
                border={"0px"} outline={"none"} _focus={{ outline: "none", border: "0px" }}
                h={"40px"} w={"100%"} px={2} borderColor={"gray.300"}
              />
            </Box>
          </Flex>
        </form>
        <Button onClick={() => {
          if (email) searchEmail();
          else groupBuyersByCompany(allLeads, search, orderSort, relevanceSort, filterIndustry, filterCountry);
        }} colorScheme="transparent" variant={"outline"} borderColor={"card.borderDark"} w={"60px"}
          _hover={{ bg: "#2E7D32", color: "white", borderColor: "#2E7D32" }} h={"30px"}>
          <Text fontSize={"sm"} fontWeight={"regular"}>Search</Text>
        </Button>
      </VStack>

      <Flex w={"100%"} justifyContent={"space-between"} flexDirection={"column"}>
        <Text mb={"4px"} fontSize={"md"} fontWeight={"medium"}>{companies?.length} buyers in list</Text>
        <Text mb={"4px"} fontSize={"xs"} fontWeight={"regular"} color={"text.caption"}>
          Click on company name for more details<br /> Click on the color icon to change relevance.
        </Text>
        <Flex gap={3} alignItems={"center"} mt={"10px"}>
          <FilterToggleButton
            buttonRef={filterToggleRef as React.LegacyRef<HTMLButtonElement>}
            buttonText="A-Z"
            onClick={() => setOrderSort(orderSort == "z-to-a" ? "a-to-z" : "z-to-a")}
          />
          <Flex bg={"white"} border={"1px solid #D9D9D9"} borderColor={"card.borderLight"} borderRadius={"md"}
            height={"25px"} alignItems={"center"} justifyContent={"center"} padding={"0 5px"}>
            <Text fontWeight={"regular"} fontSize={"xs"}>Relevance</Text>
            <RelevanceFilterComponent />
          </Flex>
          {event?.length > 0 && (
            <Select showSearch value={inputs?.event || undefined}
              onChange={(e) => setInputs({ ...inputs, event: e })} onClear={() => setInputs({ ...inputs, event: "" })}
              placeholder="Event" allowClear
              options={event?.map((ev: any) => ({
                label: ev?.eventName + " (" + moment(ev?.startDate).format("DD/MMM/YY") + ")",
                value: ev?._id,
              }))}
              style={{ height: "25px", fontSize: "12px", width: "110px" }}
            />
          )}
          <Select showSearch options={countryOptions} value={filterCountry || undefined}
            onChange={(val) => setFilterCountry(val || "")} onClear={() => setFilterCountry("")}
            placeholder="Country" allowClear
            filterOption={(input, option) => String(option?.value || "").toLowerCase().includes(input.toLowerCase())}
            style={{ height: "25px", fontSize: "12px", width: "110px" }}
          />
          <Select showSearch options={industryOptions} value={filterIndustry || undefined}
            onChange={(val) => setFilterIndustry(val || "")} onClear={() => setFilterIndustry("")}
            placeholder="Industry" allowClear
            filterOption={(input, option) => String(option?.label || "").toLowerCase().includes(input.toLowerCase())}
            style={{ height: "25px", fontSize: "12px", width: "110px" }}
          />
          <Button variant={"link"} onClick={resetFilters}>
            <Text fontSize={"sm"} fontWeight={"normal"} color={"#006CFF"}>Reset</Text>
          </Button>
        </Flex>
      </Flex>

      <Box w={"100%"} mt={"30px"} h={"100%"} overflowY={"auto"} overflowX={"hidden"} display={"flex"} flexDirection={"column"} gap={"20px"} pb={"100px"}>
        {[...companies].map((item, index) => (
          <BuyerCompanyCard
            key={"company_" + index}
            item={item}
            accordionActive={accordionActive} setAccordionActive={setAccordionActive}
            buyers={buyers} buyerCompanyListItemClick={buyerCompanyListItemClick}
            setRelevanceData={setRelevanceData} handleOpenRelevanceModal={handleOpenRelevanceModal}
            meetingData={meetingData} sellerData={sellerData} user={user} userPlan={userPlan}
            setNotesData={setNotesData} handleOpenNotesModal={handleOpenNotesModal}
            handleOpenMeetModal={handleOpenMeetModal} setMeetResponder={setMeetResponder}
            handleOpenMeetConfirmModal={handleOpenMeetConfirmModal} setCurrentMeet={setCurrentMeet}
            isNewMeetingAllowed={isNewMeetingAllowed} error={error}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SellerHome;
